module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 157.5461a59b.png";